"use client";

import React from "react";
import Link from "next/link";

const WhyChooseSmile4Me: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Why Choose Smile4Me for Emergency Dental Care in Astoria?
        </h2>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>Same-day appointments for urgent cases</li>
          <li>Flexible financing with up to 2 years, no interest</li>
          <li>Comprehensive in-house care</li>
          <li>
            Advanced technology for faster, more accurate diagnosis and
            treatment
          </li>
          <li>A caring, experienced team led by Dr. Iosif Khaimov</li>
          <li>
            Welcoming new patients; you don&apos;t need to be an existing
            patient to be seen for an emergency
          </li>
        </ul>
        <p className="text-gray-800 text-base sm:text-lg leading-relaxed font-semibold pt-2">
          If you are experiencing a dental emergency in Astoria, NY, please{" "}
          <Link
            href="/contact/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            contact us
          </Link>{" "}
          today. We are here to help you get back to feeling your best.
        </p>
      </div>
    </section>
  );
};

export default WhyChooseSmile4Me;
